import { CheckIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "flowbite-react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { useTextEditorContext } from "../../hooks/useTextEditorContext";
import { MARK_DELETION, MARK_INSERTION } from "../extensions";
import { buttonStyle } from "./TextEditorMenuStyle";

export interface TextEditorMenuButtonTrackChangesAcceptProps {
  className?: string;
  children?: React.ReactNode;
}

export const TextEditorMenuButtonTrackChangesAccept = ({
  className,
  children,
}: TextEditorMenuButtonTrackChangesAcceptProps) => {
  const { t } = useTranslation("textEditor");
  const { editor, disabled } = useTextEditorContext();

  if (!editor || (!editor.isActive(MARK_DELETION) && !editor.isActive(MARK_INSERTION))) {
    return null;
  }

  return (
    <Tooltip content={t("buttons.acceptchange")}>
      <button
        type="button"
        onClick={() => {
          if (editor) {
            editor.chain().acceptChange().focus().run();
          }
        }}
        className={twMerge(buttonStyle, className)}
        disabled={disabled}
      >
        {children ?? <CheckIcon className="h-6 w-6" />}
      </button>
    </Tooltip>
  );
};
